import type { ReactNode } from "react";
import { Box } from "@mui/material";
import { chipWrapper } from "./styles";
import { useThemeContext } from "../../../globalContext/global-context";

type ChoiceGroupProps = {
  children: ReactNode;
  isLandscapeMode: boolean;
  isList: boolean;
};

const ChoiceGroup = ({
  children,
  isLandscapeMode,
  isList,
}: ChoiceGroupProps) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  return (
    <Box
      data-testid="choice-group"
      sx={chipWrapper(isLandscapeMode, theme, isList)}
    >
      {children}
    </Box>
  );
};

export default ChoiceGroup;
